import { MenuItem } from 'primeng/api';
import { Role } from 'src/app/core/enums/role.enum';

export interface NavigationItem extends MenuItem {
  roles?: Role[];
  expandable?: boolean;
  viewAllInHorizontal?: boolean;
  hasActiveRouterLink?: boolean;
  items?: NavigationItem[];
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Favorites',
    items: [
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        routerLink: 'dashboard',
      },
      {
        label: 'Task Management',
        icon: 'pi pi-list',
        expandable: false,
        items: [
          {
            label: 'Tasks',
            icon: 'pi pi-check',
            routerLink: 'tasks',
          },
        ],
      },
      {
        label: 'Inspection Tools',
        icon: 'pi pi-search',
        expandable: false,
        items: [
          {
            label: 'Environments',
            icon: 'pi pi-globe',
            routerLink: 'environment',
          },
          {
            label: 'Scanners',
            icon: 'pi pi-camera',
            routerLink: 'scanners',
          },
          {
            label: 'Inspection Buckets',
            icon: 'pi pi-box',
            routerLink: 'inspection-bucket',
          },
        ],
      },
      {
        label: 'File Operations',
        icon: 'pi pi-folder',
        expandable: false,
        items: [
          {
            label: 'File Manager',
            icon: 'pi pi-folder-open',
            routerLink: 'file-manager',
          },
          {
            label: 'Audit Logs',
            icon: 'pi pi-file-o',
            routerLink: 'audit-logs',
            roles: [Role.Administrator],
          },
        ],
      },
    ],
  },
];
